import React, {useState, useEffect} from 'react';
import {StripeProvider as DefaultStripeProvider} from 'react-stripe-elements';
import PropTypes from 'prop-types';
import config from '../../config/app';

const StripeProvider = ({children}) => {
  const [stripe, setStripe] = useState(null);
  useEffect(() => {
    if (window.Stripe) {
      setStripe(window.Stripe(config.stripe_api_key));
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        setStripe(window.Stripe(config.stripe_api_key));
      });
    }
  }, []);
  return (
    <DefaultStripeProvider stripe={stripe}>
      {children}
    </DefaultStripeProvider>
  );
};

StripeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StripeProvider;
